import { defineMessages } from 'react-intl';

const translations = {
  title: {
    id: 'serviceCostForm.vatSettingsFormSection.title',
    defaultMessage: 'VAT settings',
    description: 'Title of the VAT settings form section of the services form',
  },
  fields: {
    type: {
      id: 'serviceCostForm.vatSettingsFormSection.fields.type.label',
      defaultMessage: 'Type',
      description: 'label of the type field in the VAT settings form section of the services form',
    },
    rate: {
      id: 'serviceCostForm.vatSettingsFormSection.fields.rate.label',
      defaultMessage: 'Rate',
      description: 'label of the Rate field in the VAT settings form section of the services form',
    },
    countryCode: {
      id: 'serviceCostForm.vatSettingsFormSection.fields.countryCode.label',
      defaultMessage: 'Country',
      description:
        'label of the country field in the VAT settings form section of the services form',
    },
  },
  errors: {
    required: {
      id: 'errors.validation.required',
      defaultMessage: '{target} is required',
      description: 'field is required error',
    },
  },
  add: {
    id: 'actions.add',
    defaultMessage: 'Add',
    description: 'label of the add button',
  },
  remove: {
    id: 'actions.remove',
    defaultMessage: 'Remove',
    description: 'label of the remove button',
  },
  vatTypes: {
    weighed: {
      id: 'serviceCostForm.vatTypes.weighed',
      defaultMessage: 'Weighed',
      description: 'label of the vat type weighed',
    },
    fixed: {
      id: 'serviceCostForm.vatTypes.fixed',
      defaultMessage: 'Fixed',
      description: 'label of the vat type fixed',
    },
    max: {
      id: 'serviceCostForm.vatTypes.max',
      defaultMessage: 'Max',
      description: 'label of the vat type max',
    },
  },
};

export default defineMessages(translations);
